import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";
import { notify } from "../../utils/utils";

const urlBaseMantenimientosDefinidos = process.env.REACT_APP_TMAN_API + '/Template'

export const useMantenimientosDefinidos = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa

    const [mantenimientos,setMantenimientos] = useState([])

    const listarMantenimientos = async () => {
        const response = await AuthFetch({
            url: urlBaseMantenimientosDefinidos + '?' + new URLSearchParams({
                CodEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setMantenimientos(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarDetalladoProductos = async (codMantenimientoPlantilla) => {
        const response = await AuthFetch({
            url: urlBaseMantenimientosDefinidos + '/detail?' + new URLSearchParams({
                CodEmpresa: codEmpresa,
                CodMantenimientoPlantilla: codMantenimientoPlantilla
            })
        })

        !response.isValid && notify(response.exceptions[0].description,'error')
        
        return response.content
    }

    const registrarEditarMantenimiento = async ({
        nombrePlantilla             = '',
        descripcionPlantilla        = '',
        detallePlantilla            = [{codRepuesto: 0,cantidad: 0}],
        codPlantilla   = 0
    }) => {
        const {codMantenimientoPlantilla,...parametrosRegistro} = {
                codEmpresa: codEmpresa,
                codUsuarioAccion: stateUser.codUsuario,
                nomMantenimientoPlantilla: nombrePlantilla,
                descripcion: descripcionPlantilla,
                detalle: detallePlantilla,

                codMantenimientoPlantilla: codPlantilla,
            }
        const response = await AuthFetch({
            url: urlBaseMantenimientosDefinidos,
            method: codMantenimientoPlantilla == 0 ? 'POST' : 'PUT',
            body: JSON.stringify(codMantenimientoPlantilla == 0 ? parametrosRegistro : {...parametrosRegistro,codMantenimientoPlantilla})
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }


    const eliminarMantenimientos = async (codMantenimientoPlantilla) => {
        const response = await AuthFetch({
            url: urlBaseMantenimientosDefinidos,
            method: 'DELETE',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUsuarioAccion: stateUser.codUsuario,
                codMantenimientoPlantilla: codMantenimientoPlantilla
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }
    
    return {
        listarMantenimientos,
        listarDetalladoProductos,
        mantenimientos,
        registrarEditarMantenimiento,
        eliminarMantenimientos
    };
};
